export default "__VITE_ASSET__48e41588__"